import React from 'react';
import { InPersonEventLocation } from './InPerson/Location';
import { OnlineEventLocation } from './OnlineEventLocation';
import { TBDEventLocation } from './TBDEventLocation';
import {
    InPersonLocation,
    InPersonMap,
    OnlineLocation,
    TBDLocation,
} from './types';

import styles from './Location.module.scss';

export type LocationProps = InPersonLocation | OnlineLocation | TBDLocation;

export const Location = ({
    location,
    map,
}: {
    location: LocationProps;
    map: InPersonMap;
}) => {
    if (location.isOnlineEvent) {
        return (
            <div className={styles.locationInfo}>
                <OnlineEventLocation onlineEventUrl={location.onlineEventUrl} />
            </div>
        );
    }

    if (location.hasAddress) {
        return (
            <div className={styles.locationInfo}>
                <InPersonEventLocation
                    venueMultilineAddress={location.venueMultilineAddress}
                    venueName={location.venueName}
                    location={map.location}
                    hasMap={map.shouldDisplayMap}
                    gMapsApiKey={map.gMapsApiKey}
                />
            </div>
        );
    }

    return (
        <div className={styles.locationInfo}>
            <TBDEventLocation />
        </div>
    );
};
